import { useAppSelector } from '../store';
import Feature from './Feature';

export default function useHasFeatureFlag(feature: Feature) {
  return useAppSelector(state =>
    state.checkoutDevice.config.featureFlags.includes(feature));
}
